export default __webpack_public_path__ + "static/media/sanofi-new.4b5db1fb.png";